import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CreateInstitutionInput } from "../../API";
import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";
import Grid from "@mui/material/Unstable_Grid2";
import { SubmitHandler, useForm } from "react-hook-form";
import { Alert } from "@mui/material";
import {
  InstitutionFormErrors,
  useCreateInstitution
} from "./institutionUtils";

const pageDetails: PageWrapperProps = {
  className: "NewInstitution",
  headerText: "New Institution"
};

export const NewInstitution = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm<CreateInstitutionInput>();
  const { newInstitution, status, error, createInstitution } =
    useCreateInstitution();

  const onSubmit: SubmitHandler<CreateInstitutionInput> = async (data) => {
    createInstitution(data);
  };

  useEffect(() => {
    if (newInstitution && newInstitution.id) {
      navigate(`/institutions/${newInstitution.id}`);
    }
  }, [newInstitution]);

  if (status === "failed" || error) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t("Error")}</h2>
        <h3>{t(InstitutionFormErrors.CreationError)}</h3>
        {error && <p>{error}</p>}
      </PageWrapper>
    );
  }

  return (
    <PageWrapper {...pageDetails}>
      <form
        className="NewInstitutionForm"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Grid container spacing={2}>
          <Grid xs={8}>
            <label htmlFor="name">{t("Institution Name")}</label>
            <input
              type="text"
              required
              placeholder={t("Institution Name")}
              style={{ width: "100%" }}
              id="name"
              disabled={status === "loading"}
              {...register("name", { required: true })}
            />
            {errors.name && (
              <Alert severity="error">
                {t(InstitutionFormErrors.EmptyInstitutionName)}
              </Alert>
            )}
          </Grid>
          <Grid xs={8}>
            <label htmlFor="description">{t("Description")}</label>
            <textarea
              placeholder={t("Description")}
              style={{ width: "100%" }}
              id="description"
              disabled={status === "loading"}
              {...register("description")}
            />
          </Grid>
          <Grid container xs={8}>
            <Grid>
              <button disabled={!isDirty || status === "loading"}>
                {t("Save")}
              </button>
            </Grid>
            <Grid>
              <button
                disabled={status === "loading"}
                onClick={() => navigate("/institutions")}
              >
                {t("Cancel")}
              </button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </PageWrapper>
  );
};
